import { Lock, Shield, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin({ denied }) {
  const signIn = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-5">
      <Seo title="Admin Sign In" path="/admin" noindex />
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(600px 400px at 20% 30%, rgba(212,175,55,0.14), transparent 60%), radial-gradient(500px 400px at 80% 70%, rgba(192,192,192,0.08), transparent 60%)",
        }}
      />

      <Link
        to="/"
        className="fixed top-6 left-6 text-white/60 hover:text-[#d4af37] text-xs uppercase tracking-widest-2"
        data-testid="admin-back-home"
      >
        ← Back to site
      </Link>

      <div className="glass-strong rounded-3xl p-10 md:p-14 max-w-md w-full text-center fade-up">
        <div className="mx-auto w-14 h-14 rounded-full bg-gradient-to-br from-[#f3e5ab] via-[#d4af37] to-[#7a5d10] text-black flex items-center justify-center">
          <Lock size={22} />
        </div>
        <div className="mt-6 text-xs uppercase tracking-widest-2 text-[#d4af37]">Shine on Coin</div>
        <h1 className="mt-2 font-display text-4xl text-white">Admin Access</h1>
        <p className="mt-4 text-white/60 text-sm">
          Sign in with your Google account to manage orders and catalog.
        </p>

        {denied && (
          <div className="mt-6 flex items-start gap-3 text-left glass rounded-2xl p-4 border border-red-500/30">
            <AlertCircle className="text-red-400 mt-0.5" size={18} />
            <div className="text-sm text-white/80">
              This Google account is not authorised for admin access.
              Ask the owner to add it to <code className="text-[#d4af37]">ADMIN_EMAILS</code>.
            </div>
          </div>
        )}

        <button
          onClick={signIn}
          className="mt-8 w-full rounded-full py-3.5 bg-white text-black font-medium hover:brightness-95 transition flex items-center justify-center gap-3"
          data-testid="admin-google-signin"
        >
          <GoogleIcon /> Sign in with Google
        </button>

        <div className="mt-8 flex items-center gap-2 justify-center text-xs text-white/40">
          <Shield size={12} /> Secured by Emergent OAuth
        </div>
      </div>
    </div>
  );
}

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);
